module.exports = __webpack_public_path__ + "img/3.25b472fa.jpg";